import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BiVideo } from "react-icons/bi";
import { DiGoogleAnalytics } from "react-icons/di";
import { FaUserCog } from "react-icons/fa";
import { PiFilesLight } from "react-icons/pi";

import { toast } from "react-toastify";
import { setUserOrganizations } from "../store/reducers/userOrganizationsSlice";
import { useDispatch, useSelector } from "react-redux";
import { FaMedal } from "react-icons/fa";
import { fetchNotifications } from "../store/reducers/notification";
import { fetchCustomPoints } from "../store/reducers/badgesDetails";
import { getOrganizationById, setSelectedOrganization } from "../store/reducers/organizationSlice";
import { FaRegQuestionCircle } from "react-icons/fa";
import { MdVideoLibrary } from "react-icons/md";
import { FaBook } from "react-icons/fa";
import { FaBookMedical } from "react-icons/fa";


const Dashboard = () => {
  const [t] = useTranslation();
  const jwtToken = localStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const organizationId = localStorage.getItem("organisation_id");
  const userId = localStorage.getItem("user_id");
  // const { data: notifications, loading, error } = useSelector((state) => state.notifications);
  const getOrganizationDetail = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/login-user-connected-in-organzation`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || "Failed to fetch organization details");
      }

      const organizations = data?.data || [];

      dispatch(setUserOrganizations(organizations));

      if (organizations.length === 0) return;

      let selectedOrg = organizations[0];

      // If already stored in localStorage use that
      const storedCustomerId = localStorage.getItem("customer_id");

      if (storedCustomerId) {
        const found = organizations.find(
          (org) => String(org.customer_id) === String(storedCustomerId)
        );
        if (found) selectedOrg = found;
      } else {
        localStorage.setItem("organisation_id", selectedOrg.organisation_id);
        localStorage.setItem("customer_id", selectedOrg.customer_id);
        localStorage.setItem("user_role_id", selectedOrg.user_role_id);
        localStorage.setItem("user_role", selectedOrg.role);
      }

      dispatch(
        setSelectedOrganization({
          organisation_id: selectedOrg.organisation_id,
          customer_id: selectedOrg.customer_id,
          user_role_id: selectedOrg.user_role_id,
          user_role: selectedOrg.role,
        })
      );
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  useEffect(() => {
    getOrganizationDetail();
  }, []);

  useEffect(() => {
    if (userId && organizationId) {
      dispatch(fetchNotifications({ userId, organizationId }));
      dispatch(getOrganizationById(organizationId))
    }
  }, [userId, organizationId, dispatch]);

  useEffect(async () => {
    if (organizationId) {
      dispatch(fetchCustomPoints(+organizationId));
    }
  }, [organizationId, dispatch]);

  const { organizations } = useSelector((state) => state.userOrganizations);
  const { organizationDetails } = useSelector((state) => state.organization);
  
  const localRole = `${localStorage.getItem("user_role") || ""}`.toLowerCase();
  const isAdmin_Owner =
    localRole === "admin" ||
    localRole === "owner" ||
    organizations.some((org) => {
      const orgRole = `${org.role || ""}`.toLowerCase();

      return (
        org.organisation_id === +localStorage.getItem("organisation_id") &&
        (orgRole === "admin" || orgRole === "owner")
      );
    });

  const isExternalInstructor = organizations.some(
    (org) =>
      org.organisation_id === +localStorage.getItem("organisation_id") &&
      org.role === "External Instructor"
  );

  return (
    <>
      <div className="text-center">
        <h4>Select Your Product</h4>
        <div className="mt-3 mx-5">
          <div className="row d-flex align-items-stretch flex-wrap">
            {/* Option 1 */}
            <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
              <div className="card bg_color h-100 w-100">
                <div className="card-body d-flex flex-column align-items-center justify-content-center">
                  <NavLink
                    to="/new-ac-analytics"
                    exact
                    className="nav-link"
                    style={{ color: "white" }}
                  >
                    <DiGoogleAnalytics size={50} />
                    <h6 style={{ marginTop: "8px" }}>
                      {t("userMenuSidebar.label.RiskAnalysis")}
                    </h6>
                  </NavLink>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
              <div className="card bg_color h-100 w-100">
                <div className="card-body d-flex flex-column align-items-center justify-content-center">
                  <NavLink
                    to="/ac-analytics"
                    exact
                    className="nav-link"
                    style={{ color: "white" }}
                  >
                    <DiGoogleAnalytics size={50} />
                    <h6 style={{ marginTop: "8px" }}>
                    Risk Analysis
                    </h6>
                  </NavLink>
                </div>
              </div>
            </div>


            {/* Option 2 */}
            <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
              <div className="card bg_color h-100 w-100 position-relative">
                <div className="card-body d-flex flex-column align-items-center justify-content-center">
                  <NavLink
                    to="/badges_dashboard"
                    exact
                    className="nav-link text-center"
                    style={{ color: "white", width: "100%" }}
                  >
                    <FaMedal size={50} />
                    <div style={{ position: "relative", width: "100%" }}>
                      <h6 style={{ marginTop: "8px", marginBottom: "0" }}>
                        {t("userMenuSidebar.label.Award_menu")}{" "}
                        <span style={{ fontSize: "12px" }}>(BETA)</span>
                      </h6>
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>

            {/* Option 3 */}
            <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
              <div className="card bg_color h-100 w-100">
                <div className="card-body d-flex flex-column align-items-center justify-content-center">
                  {localStorage.getItem("type") == "Private" ? (
                    <>
                      <BiVideo size={50} />
                      <h6 style={{ fontSize: "18px", marginTop: "8px" }}>
                        {t("userMenuSidebar.label.InstructionVideos")}
                      </h6>
                      <h6>Coming soon</h6>
                    </>
                  ) : (
                    <NavLink
                      to="/instruction-video"
                      exact
                      className="nav-link"
                      style={{ color: "white" }}
                    >
                      <BiVideo size={50} />
                      <h6 style={{ marginTop: "8px" }}>
                        {t("userMenuSidebar.label.InstructionVideos")}
                      </h6>
                    </NavLink>
                  )}
                </div>
              </div>
            </div>

            {/* Option 4 */}

            {isAdmin_Owner && (
              <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
                <div className="card bg_color h-100 w-100">
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <NavLink
                      to="/administration"
                      exact
                      className="nav-link"
                      style={{ color: "white" }}
                    >
                      <FaUserCog size={50} />
                      <h6 style={{ marginTop: "8px" }}>
                        {t("userMenuSidebar.label.Administration")}
                      </h6>
                    </NavLink>
                  </div>
                </div>
              </div>
            )}

            {/* Option 5 */}
            {!isExternalInstructor && (
              <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
                <div className="card bg_color h-100 w-100">
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <NavLink
                      to="/incident_reports_and_documentation"
                      exact
                      className="nav-link"
                      style={{ color: "white" }}
                    >
                      <PiFilesLight size={50} />
                      <h6 style={{ marginTop: "8px" }}>
                        {t(
                          "userMenuSidebar.label.Incident_reports_and_documentation"
                        )}
                      </h6>
                    </NavLink>
                  </div>
                </div>
              </div>
            )}

            {/* Option 6 */}
            {organizationDetails?.view_educational_videos && (
              <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
                <div className="card bg_color h-100 w-100">
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <NavLink
                      to="/educational-videos"
                      exact
                      className="nav-link"
                      style={{ color: "white" }}
                    >
                      <MdVideoLibrary size={50} />
                      <h6 style={{ marginTop: "8px" }}>
                        {t("userMenuSidebar.label.Educational_video")}
                      </h6>
                    </NavLink>
                  </div>
                </div>
              </div>
            )}

            {/* Option 7 */}

              <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
                <div className="card bg_color h-100 w-100">
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <NavLink
                      to="/quizzes"
                      exact
                      className="nav-link"
                      style={{ color: "white" }}
                    >
                      <FaRegQuestionCircle size={50} />
                      <h6 style={{ marginTop: "8px" }}>
                        {t("userMenuSidebar.label.Quizzes")}
                      </h6>
                    </NavLink>
                  </div>
                </div>
              </div>
            

            {/* Option 8 */}
            {organizationDetails?.view_ac_online && (
              <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
                <div className="card bg_color h-100 w-100">
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <NavLink
                      to="/view-ac-cards"
                      exact
                      className="nav-link"
                      style={{ color: "white" }}
                    >
                      <FaBookMedical size={50} />
                      <h6 style={{ marginTop: "8px" }}>
                        {t("userMenuSidebar.label.View_AC")}
                      </h6>
                    </NavLink>
                  </div>
                </div>
              </div>
            )}

            {organizationDetails?.view_employee_pdfs && (
              <div className="col-12 col-sm-6 col-md-3 mb-4 d-flex">
                <div className="card bg_color h-100 w-100">
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <NavLink
                      to="/employee-pdfs"
                      exact
                      className="nav-link"
                      style={{ color: "white" }}
                    >
                      <FaBook size={50} />
                      <h6 style={{ marginTop: "8px" }}>Employee PDFs</h6>
                    </NavLink>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
